// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small-button {
  font-size: 11px;
  padding: 10px 2px;
  height: 28px;
}

.button-row {
  margin-top: 10px;
  justify-content: flex-end;
  display: flex;
}

.submit-button {
  height: 40px;
}

.button-container {
  display: flex;
  gap: 2px;
  justify-content: flex-end;
}

.input-container {
  position: relative;
  justify-content: flex-start;
  height: 60px;
}

@media (max-width: 576px) {
  .button-container {
    flex-direction: row;
    width: auto;
    justify-content: flex-end;
  }
}
.mt-3 {
  margin-top: 1rem !important;
}

.text {
  padding-left: 0%;
  margin-top: 1.75rem;
  padding-right: 0%;
}

.input-with-icon {
  position: relative;
}
.input-with-icon input {
  padding-right: 2.5rem;
}
.input-with-icon .calendar-icon {
  position: absolute;
  right: 10px;
  top: 65%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 1.2rem;
  color: #6c757d;
}

.uniform-width {
  display: flex;
  align-items: center;
}

.input-container {
  margin-top: 0%;
}
.input-container .mc-input,
.input-container .mc-input-date {
  flex: 1 1;
  min-width: 0;
}

.submit-button {
  flex-shrink: 0;
  margin-left: 8px;
}

.refresh-status-btn {
  display: flex;
  align-items: center;
  background-color: white;
  color: black;
  border: 1px solid var(--mp-border-info-color);
  border-radius: 4px;
  padding: 4px 4px;
  font-size: 12px;
  height: 30px;
  width: 30px;
  cursor: pointer;
  margin: 0 0 0 0;
  transition: background-color 0.2s;
}

.refresh-status-btn:hover {
  background-color: white;
}

.refresh-status-btn .me-2 {
  margin-right: 8px;
}

.input-container {
  margin-top: 0%;
}

.container-search-heading {
  font-size: 22px;
  margin: 0;
  color: #333;
}

.mc-label.medium {
  font-size: large;
}

@media (min-width: 761px) and (max-width: 1029px) {
  .submit-button {
    flex-shrink: 0;
    margin-left: auto;
    margin-top: 0;
    width: auto;
  }
  .input-container {
    flex-basis: 100%;
    margin-right: 8px;
  }
  .button-row {
    justify-content: center;
  }
}
/* Responsive design for smaller screens */
@media (max-width: 760px) {
  .input-container {
    margin-bottom: 10px;
  }
  .submit-button {
    margin-top: 10px;
    margin-left: 0;
    width: 100%;
  }
}
/* Fine-tune spacing for the 5-column layout */
@media (min-width: 1030px) {
  .input-container {
    padding-right: 8px;
  }
  .input-container:last-child {
    padding-right: 0;
  }
}
@media (min-width: 1030px) {
  /* reduce right padding for the last input column (To + Search) */
  .filters-box .input-container:last-child {
    padding-right: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/ContainerSearchForm/ContainerSearchForm.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AACF;;AACA;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,aAAA;EACA,QAAA;EACA,yBAAA;AAGF;;AADA;EACE,kBAAA;EACA,2BAAA;EACA,YAAA;AAIF;;AAEA;EACE;IACE,mBAAA;IACA,WAAA;IACA,yBAAA;EACF;AACF;AACA;EACE,2BAAA;AACF;;AAGA;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;;AAEE;EACE,kBAAA;AACJ;AACI;EACE,qBAAA;AACN;AAEI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AAAN;;AAIE;EACE,aAAA;EACA,mBAAA;AADJ;;AAIC;EACC,cAAA;AADF;AAEE;;EAEE,SAAA;EACA,YAAA;AAAJ;;AAMA;EACE,cAAA;EACA,gBAAA;AAHF;;AAMC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACF,eAAA;EACE,iCAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,iBAAA;AAHF;;AAKA;EACE,cAAA;AAFF;;AAIA;EACE,eAAA;EAEA,SAAA;EACA,WAAA;AAFF;;AAIA;EACE,gBAAA;AADF;;AAGA;EACE;IACE,cAAA;IACA,iBAAA;IACA,aAAA;IACA,WAAA;EAAF;EAGA;IACE,gBAAA;IACA,iBAAA;EADF;EAIA;IACE,uBAAA;EAFF;AACF;AAKA,0CAAA;AACA;EACE;IACE,mBAAA;EAHF;EAMA;IACE,gBAAA;IACA,cAAA;IACA,WAAA;EAJF;AACF;AAOA,8CAAA;AACA;EACE;IACE,kBAAA;EALF;EAQA;IACE,gBAAA;EANF;AACF;AAQA;EACE,iEAAA;EACA;IACE,mBAAA;EANF;AACF","sourcesContent":[".small-button {\n  font-size: 11px;\n  padding: 10px 2px; \n  height: 28px;\n}\n.button-row {\n  margin-top: 10px;\n  justify-content: flex-end;\n  display: flex;\n}\n.submit-button {\n  height: 40px;\n}\n\n.button-container {\n  display: flex;\n  gap: 2px; \n  justify-content: flex-end;\n}\n.input-container {\n  position: relative;\n  justify-content: flex-start;\n  height: 60px; \n}\n\n\n\n\n@media (max-width: 576px) {\n  .button-container {\n    flex-direction: row;\n    width: auto;\n    justify-content: flex-end;\n  }\n}\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n\n.text{\n    padding-left: 0%;\n    margin-top: 1.75rem;\n    padding-right: 0%;\n  }\n  .input-with-icon{\n    position: relative;\n    \n    input{\n      padding-right: 2.5rem;\n    }\n  \n    .calendar-icon{\n      position: absolute;\n      right: 10px;\n      top: 65%;\n      transform: translateY(-50%);\n      pointer-events: none;\n      font-size: 1.2rem;\n      color: #6c757d;\n    }\n    \n  }\n  .uniform-width{\n    display: flex;\n    align-items: center;\n  \n  }\n .input-container{\n  margin-top: 0%;\n  .mc-input,\n  .mc-input-date{\n    flex: 1; \n    min-width: 0;\n\n  }\n }\n \n\n.submit-button {\n  flex-shrink: 0; \n  margin-left: 8px; \n}\n\n .refresh-status-btn {\n  display: flex;\n  align-items: center;\n  background-color: white;\n  color: black;\n  border: 1px solid var(--mp-border-info-color);\n  border-radius: 4px;\n  padding: 4px 4px;\n  font-size: 12px;\n  height: 30px;\n  width: 30px;\n  cursor: pointer;\nmargin: 0 0 0 0;\n  transition: background-color 0.2s;\n}\n\n.refresh-status-btn:hover {\n  background-color: white;\n}\n\n.refresh-status-btn .me-2 {\n  margin-right: 8px; \n}\n.input-container{\n  margin-top: 0%;\n}\n.container-search-heading{\n  font-size: 22px;\n  // font-weight: bold;\n  margin: 0;\n  color: #333;\n}\n.mc-label.medium{\n  font-size: large;\n}\n@media (min-width: 761px) and (max-width: 1029px) {\n  .submit-button {\n    flex-shrink: 0;\n    margin-left: auto; \n    margin-top: 0;\n    width: auto; \n  }\n\n  .input-container {\n    flex-basis: 100%;\n    margin-right: 8px;\n  }\n\n  .button-row {\n    justify-content: center; \n  }\n}\n\n/* Responsive design for smaller screens */\n@media (max-width: 760px) {\n  .input-container {\n    margin-bottom: 10px;\n  }\n  \n  .submit-button {\n    margin-top: 10px;\n    margin-left: 0;\n    width: 100%;\n  }\n}\n\n/* Fine-tune spacing for the 5-column layout */\n@media (min-width: 1030px) {\n  .input-container {\n    padding-right: 8px;\n  }\n  \n  .input-container:last-child {\n    padding-right: 0;\n  }\n}\n@media (min-width: 1030px) {\n  /* reduce right padding for the last input column (To + Search) */\n  .filters-box .input-container:last-child {\n    padding-right: 11px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
